module.exports = __webpack_public_path__ + "img/huifa-introduce.ae88d5a4.png";